import { render } from "./NutricionProximosDias.vue?vue&type=template&id=7eaa3dd1&scoped=true"
import script from "./NutricionProximosDias.vue?vue&type=script&lang=js"
export * from "./NutricionProximosDias.vue?vue&type=script&lang=js"

import "./NutricionProximosDias.vue?vue&type=style&index=0&id=7eaa3dd1&scoped=true&lang=css"
import "./NutricionProximosDias.vue?vue&type=style&index=1&id=7eaa3dd1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eaa3dd1"]])

export default __exports__